{
  "table": {
    "complianceState": "Estado de cumplimiento",
    "complianceStateOptions": {
      "ANY": "Cualquiera",
      "APPROVED": "Aprobado",
      "NEEDS_REVIEW": "Necesita revisión",
      "REJECTED": "Rechazado"
    },
    "accountType": "Tipo de cuenta",
    "state": "Estado",
    "stateOptions": {
      "ANY": "Cualquiera",
      "ACTIVE": "Activo",
      "AWAITING_APPROVAL": "En espera de aprobación",
      "INACTIVE": "Inactivo"
    },
    "iDVerified": "ID verificada",
    "idVerifiedOptions": {
      "ANY": "Cualquiera",
      "YES": "Sí",
      "NO": "No"
    },
    "organization": "Organización",
    "client": "Cliente",
    "account": "Cuenta",
    "age": "Edad",
    "annualIncome": "Ingresos anuales",
    "annualDebtPayments": "Pagos anuales de deuda",
    "totalDebt": "Deuda total",
    "liquidAssets": "Activos líquidos",
    "totalAssets": "Total de activos",
    "netWorth": "Patrimonio neto",
    "debtAssetRatio": "Relación deuda-activos",
    "debtServiceRatio": "Índice de cobertura del servicio de la deuda",
    "employment": "Empleo",
    "jobTitle": "Puesto",
    "companyType": "Tipo de empresa",
    "entityOfInterest": "Persona o entidad de interés",
    "userSuitablitiy": "Puntuación de idoneidad del usuario",
    "goalSuitability": "Puntuación de idoneidad de la meta",
    "suggestedPortfolio": "Cartera sugerida",
    "idVerified": "ID verificada",
    "actualPortfolio": "Cartera",
    "completedAt": "Completado en",
    "subAccountStatus": "Estado de subcuenta",
    "actions": "Acciones",
    "yes": "Sí",
    "no": "No",
    "new": "Nuevo",
    "updated": "Actualizado",
    "isVulnerablePerson": "Persona vulnerable",
    "isOwnerOfEntity": "Propietario de la entidad"
  },
  "approveAndSign": "Aprobar y firmar",
  "inherited": "Heredado - "
}
